module.exports = __webpack_public_path__ + "static/cheers-abstract.e7d82de0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cheers-abstract.png
// module id = 348
// module chunks = 52007029612993 174448160903362